<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Finish Good Quality Inspect Inbox" active>

                                <b-row v-if="hasFailedDataFinishGoodQualityInspectInbox">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQualityInspectInbox.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectInboxsFailed" :fields="fieldsFinishGoodQualityInspectInbox" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectInbox" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyPending)="row">
													{{ Number(row.item.qtyPending).toLocaleString() }}
												</template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQualityInspectInbox.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectInboxs" :fields="fieldsFinishGoodQualityInspectInbox" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectInbox" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyPending)="row">
													{{ Number(row.item.qtyPending).toLocaleString() }}
												</template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Finish Good Quality Inspect Ng Inbox" active>

                                <b-row v-if="hasFailedDataFinishGoodQualityInspectNgInbox">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQualityInspectNgInbox.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectNgInboxsFailed" :fields="fieldsFinishGoodQualityInspectNgInbox" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectNgInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectNgInbox" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQualityInspectNgInbox.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQualityInspectNgInboxs" :fields="fieldsFinishGoodQualityInspectNgInbox" :busy="isDataLoading"
                                                         :sort-by.sync="sortByFinishGoodQualityInspectNgInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectNgInbox" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyNg)="row">
													{{ Number(row.item.qtyNg).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import FinishGoodQualityInspectInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox';
import FinishGoodQualityInspectInboxList from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxList';
import FinishGoodQualityInspectInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsFinishGoodQualityInspectInbox: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Before", key: 'qtyBefore', sortable: false},
				{"class" : "th-status", "label" : "Qty After", key: 'qtyAfter', sortable: false},
				{"class" : "th-status", "label" : "Qty Pending", key: 'qtyPending', sortable: false},
				{"class" : "th-status", "label" : "Qty Ng", key: 'qtyNg', sortable: false},
				{"class" : "th-status", "label" : "Metode Qc", key: 'metodeQcName', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Detail", key: 'workOrderProcessDetailPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsFinishGoodQualityInspectNgInbox: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Problem Category", key: 'problemCategoryCode', sortable: false},
				{"class" : "th-status", "label" : "QtyNg", key: 'qtyNg', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			finishGoodQualityInspectInboxs : [],
			finishGoodQualityInspectInboxsFailed: [],
			finishGoodQualityInspectInboxId : '',
			sortByFinishGoodQualityInspectInbox: '',
			sortDescFinishGoodQualityInspectInbox: '',
			hasFailedDataFinishGoodQualityInspectInbox: false,
			totalFailedFinishGoodQualityInspectInbox: 0,
			totalSucceedFinishGoodQualityInspectInbox: 0,
			finishGoodQualityInspectNgInboxs : [],
			finishGoodQualityInspectNgInboxsFailed: [],
			finishGoodQualityInspectNgInboxId : '',
			sortByFinishGoodQualityInspectNgInbox: '',
			sortDescFinishGoodQualityInspectNgInbox: '',
			hasFailedDataFinishGoodQualityInspectNgInbox: false,
			totalFailedFinishGoodQualityInspectNgInbox: 0,
			totalSucceedFinishGoodQualityInspectNgInbox: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('finishgoodqualityinspectinbox/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('finishgoodqualityinspectinbox/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getFinishGoodQualityInspectInboxForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getFinishGoodQualityInspectInboxForUpload : async function() {
			let _this = this;
			this.$http.get('finishgoodqualityinspectinbox/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.finishGoodQualityInspectInboxs = [];
_this.finishGoodQualityInspectNgInboxs = [];


					if (response != null) {
						let result = response.data;
						_this.finishGoodQualityInspectInboxs = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedFinishGoodQualityInspectInbox = _this.finishGoodQualityInspectInboxs.length;

						_this.finishGoodQualityInspectInboxsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataFinishGoodQualityInspectInbox = true;
						_this.totalFailedFinishGoodQualityInspectInbox = 0;
						if(_this.finishGoodQualityInspectInboxsFailed == undefined || _this.finishGoodQualityInspectInboxsFailed.length === 0) _this.hasFailedDataFinishGoodQualityInspectInbox = false;
						if(_this.hasFailedDataFinishGoodQualityInspectInbox) _this.totalFailedFinishGoodQualityInspectInbox = _this.finishGoodQualityInspectInboxsFailed.length;
						_this.finishGoodQualityInspectNgInboxs = [];
						_this.finishGoodQualityInspectNgInboxsFailed = [];
						_this.hasFailedDataFinishGoodQualityInspectNgInbox = true;
						_this.totalSucceedFinishGoodQualityInspectNgInbox = 0;
						result.forEach(function(element) {
							_this.finishGoodQualityInspectNgInboxs.push(...element.finishGoodQualityInspectNgInboxs.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedFinishGoodQualityInspectNgInbox = _this.finishGoodQualityInspectNgInboxs.length;

							_this.finishGoodQualityInspectNgInboxsFailed.push(...element.finishGoodQualityInspectNgInboxs.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.finishGoodQualityInspectNgInboxsFailed == undefined || _this.finishGoodQualityInspectNgInboxsFailed.length === 0) _this.hasFailedDataFinishGoodQualityInspectNgInbox = false;
							if(_this.hasFailedDataFinishGoodQualityInspectNgInbox) _this.totalFailedFinishGoodQualityInspectNgInbox = _this.finishGoodQualityInspectNgInboxsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'finishgoodqualityinspectinbox/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'FinishGoodQualityInspectInbox.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterFinishGoodQualityInspectInbox = new FinishGoodQualityInspectInboxFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
